/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import { AgileTaskIcon, BugIcon, EpicIcon, UserStoryIcon } from '@sketchnote/icons';
import {
  getPrioriyLabel,
  priorityOptions,
  PrioritySelectOption,
  PrioritySelectSingleValue,
  prioritySelectStyles,
  renderPriorities,
  UserSelectDropDownIndicator,
} from '@sketchnote/shared-components';
import cn from 'classnames';
import * as React from 'react';
import Select from 'react-select';
import { useBoardStore } from 'src/features/boards';
import { useKanbanStore } from 'src/features/kanban';

import { useAgileStore } from '../../store';

const { useCallback, useState, useEffect } = React;

export const options = [
  { id: '1', color: '#FFA8A8', name: 'Story', icon: <UserStoryIcon />, type: 'story' },
  { id: '2', color: '#A8D0FF', name: 'Bug', icon: <BugIcon />, type: 'bug' },
  { id: '3', color: '#C4C4C4', name: 'Task', icon: <AgileTaskIcon />, type: 'task' },
  { id: '4', color: '#FD9740', name: 'Epic', icon: <EpicIcon />, type: 'epic' },
];

export const TypeCell = ({ task: item }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState<any>({
    id: '1',
    color: '#FFA8A8',
    name: 'Story',
    icon: <UserStoryIcon />,
    type: 'story',
  });

  useEffect(() => {
    const newType = options.find((option) => option.type === item.type);
    if (newType) setType(newType);
  }, [item]);

  const { onUpdateItemField, setItem } = useAgileStore((s) => ({
    onUpdateItemField: s.onUpdateItemField,
    setItem: s.setItem,
  }));

  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);

  const handleTypeCell = async (value) => {
    setType(value);
    if (item._id) {
      onUpdateItemField({
        item: {
          type: value.type,
          _id: item._id,
        },
        keys: ['type'],
      });
      setItem(
        {
          ...item,
          type: value?.type,
        },
        item.id
      );
    }
  };

  // const handleChange = (value) => {

  // };
  return (
    <React.Fragment>
      <Menu isOpen={isOpen} onClose={close} onOpen={open}>
        <MenuButton as="div" className="h-50 w-full flex items-center px-30 ">
          <button className="flex w-full items-center">
            <span className="mr-8 block">{type.icon}</span>
            <span className="text-sm block  font-medium">
              {type.name[0].toUpperCase() + type.name.substring(1)}
            </span>
          </button>
        </MenuButton>

        <Portal>
          <div className="more-menu-popover">
            <MenuList>
              <div
                className="bg-white p-6 flex flex-col gap-0 justify-center min-w-200"
                style={{
                  boxShadow: ' 0px 2px 12px rgba(19, 23, 32, 0.08)',
                  borderRadius: '8px',
                }}
              >
                {options.map((labelOption) => {
                  return (
                    <MenuItem
                      onClick={handleTypeCell.bind(null, labelOption)}
                      key={labelOption.id}
                      className="flex px-10 h-40 items-center "
                    >
                      <span className="mr-8 block">{labelOption.icon}</span>
                      <span className="text-sm block  font-medium">
                        {labelOption.name[0].toUpperCase() + labelOption.name.substring(1)}
                      </span>
                    </MenuItem>
                  );
                })}
              </div>
            </MenuList>
          </div>
        </Portal>
      </Menu>
    </React.Fragment>
  );
};
